import { COLLABORATOR_ROLES } from "~/types/collaborator-role";

type CollaboratorRole = (typeof COLLABORATOR_ROLES)[number];
type Category = "PUBLICATION";

const publishingDeclarations: Record<CollaboratorRole, string> = {
  AUTHOR:
    "I represent and warrant that this book was written by me, subject to acceptable de minimis Artificial Intelligence (AI) use that does not affect the copyrightable authorship of my work and, in practical terms, does not alter its human-created nature.",
  CO_AUTHOR:
    "I represent and warrant that my contributions as a co-author of this book were created by me, subject to acceptable de minimis Artificial Intelligence (AI) use that does not affect the copyrightable authorship of my work and, in practical terms, does not alter its human-created nature.",
  COVER_ILLUSTRATOR:
    "I represent and warrant that the cover illustrations of this book were created by me, subject to acceptable de minimis Artificial Intelligence (AI) use that does not affect the copyrightable authorship of my work and, in practical terms, does not alter its human-created nature.",
  INTERNAL_ILLUSTRATOR:
    "I represent and warrant that the internal drawings and figures in this book were created by me, subject to acceptable de minimis Artificial Intelligence (AI) use that does not affect the copyrightable authorship of my work and, in practical terms, does not alter its human-created nature.",
  INTERNAL_PHOTOGRAPHER:
    "I represent and warrant that the internal photographs in this book were taken by me, subject to acceptable de minimis Artificial Intelligence (AI) use that does not affect the copyrightable authorship of my work and, in practical terms, does not alter its human-created nature.",
  TRANSLATOR:
    "I represent and warrant that the translation of this book was performed by me, subject to acceptable de minimis Artificial Intelligence (AI) use that does not affect the copyrightable authorship of my work and, in practical terms, does not alter its human-created nature.",
  COLLECTIONS_EDITOR:
    "I represent and warrant that my editorial work on this book was performed by me, subject to acceptable de minimis Artificial Intelligence (AI) use that does not affect the copyrightable authorship of my work and, in practical terms, does not alter its human-created nature.",
  FOREWORD:
    "I represent and warrant that the foreword of this book was written by me, subject to acceptable de minimis Artificial Intelligence (AI) use that does not affect the copyrightable authorship of my work and, in practical terms, does not alter its human-created nature.",
  GHOST_WRITER:
    "I represent and warrant that my contributions as the ghost writer of this book were created by me, subject to acceptable de minimis Artificial Intelligence (AI) use that does not affect the copyrightable authorship of my work and, in practical terms, does not alter its human-created nature.",
  PRODUCER:
    "I represent and warrant that my contribution to this book was created by me, subject to acceptable de minimis Artificial Intelligence (AI) use that does not affect the copyrightable authorship of my work and, in practical terms, does not alter its human-created nature.",
  COVER_ART_DESIGNER:
    "I represent and warrant that my contribution to this book was created by me, subject to acceptable de minimis Artificial Intelligence (AI) use that does not affect the copyrightable authorship of my work and, in practical terms, does not alter its human-created nature.",
};

const defaultDeclaration = {
  PUBLICATION:
    "I represent and warrant that my contribution to this book was created by me, subject to acceptable de minimis Artificial Intelligence (AI) use that does not affect the copyrightable authorship of my work and, in practical terms, does not alter its human-created nature.",
};

export const FilterAiUsageOptionsByRole = (
  role: CollaboratorRole,
  category: Category = "PUBLICATION"
): React.ReactNode => {
  const text = publishingDeclarations[role] ?? defaultDeclaration[category];
  return (
    <p>
      {text.split("de minimis").map((part, i, arr) =>
        i < arr.length - 1 ? (
          <span key={i}>
            {part}
            <i className="font-bold">de minimis</i>
          </span>
        ) : (
          <span key={i}>{part}</span>
        )
      )}
    </p>
  );
};

export const FilterAiUsageOptionsByRoles = (
  roles: CollaboratorRole[],
  category: Category = "PUBLICATION"
): Array<{ role: CollaboratorRole; text: React.ReactNode }> => {
  return roles.map((role) => ({
    role,
    text: FilterAiUsageOptionsByRole(role, category),
  }));
};
